import makeRequest from "api/makeRequest";
import { RequstMethods } from "api/requestMethode";
import url from "api/urls";

export class SettingsService {
    static async get() {
        return await makeRequest(url.settings.get, RequstMethods.GET);
    }

    static async update(payload: {
        instructionTitle: string;
        instructionContent: string;
        dashboardInstructionTitle: string;
        dashboardInstructionContent: string;
    }) {
        return await makeRequest(url.settings.update, RequstMethods.POST, payload);
    }
}
